import { Persistor, store } from "../store";
import { PersistGate } from "redux-persist/integration/react";
import { Provider } from "react-redux";

import InitComponent from "./init";

function Init({ children }) {
  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={Persistor}>
        <InitComponent>{children}</InitComponent>
      </PersistGate>
    </Provider>
  );
}

export default Init;
